//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { omit, get, find } from 'lodash';
import { syncAssignmentStatusToFirestore } from 'utils/methods/assignmentStatusFirestore';
//  -- Actions ------------------------
import * as ClassQuizActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import moment from "moment"
import { setLoadQuizAndClassActivity } from 'store/loadClassActivityAndQuiz/action';
import { handleListClassActivities } from 'store/classActivities/thunks';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create class quiz --------------
export const handleCreateClassQuizGoogle = (data, googleId) => async (dispatch) => {
    await dispatch(ClassQuizActions.createClassQuiz());

    try {
        data.scheduleAt =data.scheduleAt&&moment(data.scheduleAt).isValid()?data.scheduleAt: moment().toString()
        let dataClassQuiz = omit(data, ['studentsSelected', 'dueDateDif', 'retakesDif', 'levelExercise'])
        if (dataClassQuiz.classes && dataClassQuiz.classes.length > 0) {
            dataClassQuiz.classes = dataClassQuiz.classes.map(cls => ({ ...cls , users:cls.users?cls.users:[] }))
        }    
        const clsAct = await apis.post('classQuizzesRDS', `/classQuizzesMultipleDiff`, {
            body: { quiz: dataClassQuiz , selectedAssignments: data.selectedAssignments, googleId: googleId }
        });
        if (typeof clsAct == "object" && !clsAct.error) {
            const update = {
                ...clsAct.quiz.filter(act => act.classId == data.classId)[0],
                diff:get(clsAct,"diff",[]),
                data: omit(dataClassQuiz, ['activityId', 'classId', 'dueData']),
                selectedAssignments: data.selectedAssignments
            };

            await dispatch(ClassQuizActions.createClassQuizSuccess(update));
        }
        dispatch(handleListClassQuizzes(data.classId));
        dispatch(handleListClassActivities(data.classId));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating class quiz',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'CREATE_CLASS_QUIZ'
            });
        }
        await dispatch(ClassQuizActions.createClassQuizFail(error));
    }
};

export const handleCreateClassQuizSchoology = (data, schoologyid) => async (dispatch) => {
    await dispatch(ClassQuizActions.createClassQuiz());

    try {
        data.scheduleAt =data.scheduleAt&&moment(data.scheduleAt).isValid()?data.scheduleAt: moment().toString()
        let dataClassQuiz = omit(data, ['studentsSelected', 'dueDateDif', 'retakesDif', 'levelExercise'])
        if (dataClassQuiz.classes && dataClassQuiz.classes.length > 0) {
            dataClassQuiz.classes = dataClassQuiz.classes.map(cls => ({ ...cls , users:cls.users?cls.users:[] }))
        }    
        const clsAct = await apis.post('classQuizzesRDS', `/classQuizzesMultipleSchoology`, {
            body: { quiz: dataClassQuiz , selectedAssignments: data.selectedAssignments, schoologyid: schoologyid }
        });
        if (typeof clsAct == "object" && !clsAct.error) {
            const update = {
                ...clsAct.quiz.filter(act => act.classId == data.classId)[0],
                diff:get(clsAct,"diff",[]),
                data: omit(dataClassQuiz, ['activityId', 'classId', 'dueData']),
                selectedAssignments: data.selectedAssignments
            };

            await dispatch(ClassQuizActions.createClassQuizSuccess(update));
        }
        dispatch(handleListClassQuizzes(data.classId));
        dispatch(handleListClassActivities(data.classId));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating class quiz',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'CREATE_CLASS_QUIZ'
            });
        }
        await dispatch(ClassQuizActions.createClassQuizFail(error));
    }
};

//  -- Create class quiz --------------
export const handleCreateClassQuiz = (data) => async (dispatch) => {
    await dispatch(ClassQuizActions.createClassQuiz());

    try {
        data.scheduleAt =data.scheduleAt&&moment(data.scheduleAt).isValid()?data.scheduleAt: moment().toString()
        let dataClassQuiz = omit(data, ['studentsSelected', 'dueDateDif', 'retakesDif', 'levelExercise'])
        if (dataClassQuiz.classes && dataClassQuiz.classes.length > 0) {
            dataClassQuiz.classes = dataClassQuiz.classes.map(cls => ({ ...cls , users:cls.users?cls.users:[] }))
        }    
        const clsAct = await apis.post('classQuizzesRDS', `/classQuizDiff`, {
            body: { quiz: dataClassQuiz }
        });
        if (typeof clsAct == "object" && !clsAct.error) {
            const update = {
                ...clsAct.quiz.filter(act => act.classId == data.classId)[0],
                diff:get(clsAct,"diff",[]),
                data: omit(dataClassQuiz, ['activityId', 'classId', 'dueData'])
            };

            await dispatch(ClassQuizActions.createClassQuizSuccess(update));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating class quiz',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'CREATE_CLASS_QUIZ'
            });
        }
        await dispatch(ClassQuizActions.createClassQuizFail(error));
    }
};

//  -- Delete class quiz --------------
export const handleDeleteClassQuiz = (quizID, classId) => async (dispatch) => {
    await dispatch(ClassQuizActions.deleteClassQuiz());

    try {
        await apis.del('classQuizzesRDS', `/classQuizzesDiff/${quizID}?classId=${classId}`);
        await dispatch(ClassQuizActions.deleteClassQuizSuccess({ id: quizID }));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting class quiz',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'DELETE_CLASS_QUIZ'
            });
        }
        await dispatch(ClassQuizActions.deleteClassQuizFail(error));
    }
};

export const handleDeleteClassQuizForClasses = (quizID, classIds, currentClassId) => async (dispatch) => {
    if (!quizID || !Array.isArray(classIds) || classIds.length === 0) return;
    await dispatch(ClassQuizActions.deleteClassQuiz());
    try {
        await apis.del('classQuizzesRDS', `/classQuizzesDiff/${quizID}`, {
            body: { classId: classIds }
        });
        const checkClassId = classIds.includes(currentClassId)
        await dispatch(ClassQuizActions.deleteMultiClassQuizSuccess({ id: quizID, checkClassId: checkClassId, classIds: classIds }));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting class quiz for classes',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'DELETE_CLASS_QUIZ'
            });
        }
        await dispatch(ClassQuizActions.deleteClassQuizFail(error));
    }
};



//  -- List class quizzes -------------
export const handleListClassQuizzes = (classID) => async (dispatch) => {
    await dispatch(ClassQuizActions.listClassQuizzes());
    try {
        const quizzes = [];
        const quizzesRDS = classID ? await apis.get('classQuizzesRDS', `/classQuizzesData/${classID}`) : [];
        if (Array.isArray(quizzesRDS) && quizzesRDS.length > 0) {
            quizzes.push(...quizzesRDS);
        }
        await dispatch(ClassQuizActions.listClassQuizzesSuccess(quizzes));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class quizzes',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'LIST_CLASS_QUIZ'
            });
        }
        await dispatch(ClassQuizActions.listClassQuizzesFail(error));
    }
};


export const handleListClassQuizzesForStudent = (classId ,userId ) => async (dispatch) => {
    await dispatch(ClassQuizActions.listClassQuizzes());
    try {
        await dispatch(setLoadQuizAndClassActivity({classQuiz: false}));
        const quizzes = [];
        const quizzesRDS =  await apis.get('classQuizzesRDS', `/classQuizDataStudent/${classId}/${userId}`);
        if (Array.isArray(quizzesRDS) && quizzesRDS.length > 0) {
            quizzes.push(...quizzesRDS);
        }
        await dispatch(setLoadQuizAndClassActivity({classQuiz: true}));
        await dispatch(ClassQuizActions.listClassQuizzesSuccess(quizzes));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class quizzes for student',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'LIST_CLASS_QUIZ_FEEDBACK_STUDENT'
            });
        }
        await dispatch(setLoadQuizAndClassActivity({classQuiz: false}));
        await dispatch(ClassQuizActions.listClassQuizzesFail(error));
    }
};
//  -- Update class quiz --------------
export const handleUpdateClassQuiz = (quizID, data , updateTOAllClass, linkedSectionClassIds) => async (dispatch) => {
    await dispatch(ClassQuizActions.updateClassQuiz());
    try {
        let body = {
            quizId: quizID,
            quiz: data,
            updateTOAllClass,
            linkedSectionClassIds: linkedSectionClassIds ?? undefined
        }
        await apis.put('classQuizzesRDS', `/classQuizzesDiff`, { body });
        await dispatch(ClassQuizActions.updateClassQuizSuccess({ id: quizID, ...data }));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating class quiz',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'UPDATE_CLASS_QUIZ'
            });
        }
        await dispatch(ClassQuizActions.updateClassQuizFail(error));
    }
};


export const handleChangeStatusQuizzes = (quizId, active) => async (dispatch, getState) => {
    if (!quizId) return;
    try {
        const statusData = await apis.put('classQuizzesRDS', `/changeStatus`, {
            body: {
                id: quizId,
                active: active
            }
        });
        if (statusData) {
            await dispatch(ClassQuizActions.updateClassQuizSuccess({ id: quizId, ...statusData }));
        }
        const state = getState();
        const classId = state.currentClass?.id;
        const list = state.classQuizzes ?? [];
        const row =
            find(list, (x) => String(x.id) === String(quizId)) ||
            find(list, (x) => String(x.quizId) === String(quizId));
        const contentId = row?.quizId ?? get(row, 'data.id');
        if (classId && contentId) {
            await syncAssignmentStatusToFirestore({ classId, kind: 'quiz', contentId, active });
        }
        return statusData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'changing status quizzes',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'CREATE_STUDENT_QUIZ'
            });
        }
    }
};

export const handleListClassQuizzesForStudentWithIds = (classId ,userId , ids = []) => async (dispatch) => {
    await dispatch(ClassQuizActions.listClassQuizzes());
    try {
        await dispatch(setLoadQuizAndClassActivity({classQuiz: false}));
        const quizzes = [];
        const quizzesRDS =  await apis.post('classQuizzesRDS', `/classQuizDataStudentWithIds`, {
            body: {
                classId,
                userId,
                quizIds: ids
            }
        });
        if (Array.isArray(quizzesRDS) && quizzesRDS.length > 0) {
            quizzes.push(...quizzesRDS);
        }
        await dispatch(setLoadQuizAndClassActivity({classQuiz: true}));
        if(quizzes?.length > 0){
            quizzes.forEach(item => {
                if(item?.quizId){
                    dispatch(ClassQuizActions.listClassQuizzesForStudentWithIds(item));
                }
            })
        }else{
            dispatch(ClassQuizActions.listClassQuizzesForStudentWithIds({activityIds: ids, isDeleted: true}));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class quizzes for student',
                error,
                module: 'CLASS_QUIZZES',
                operation: 'LIST_CLASS_QUIZ_FEEDBACK_STUDENT'
            });
        }
        await dispatch(setLoadQuizAndClassActivity({classQuiz: false}));
        await dispatch(ClassQuizActions.listClassQuizzesFail(error));
    }
};